import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {
  transform(timeSec: number | null): string {
    if (timeSec === null || timeSec < 0) {
      return '';
    }

    // Hours, minutes and seconds
    const hrs = Math.floor(timeSec / 3600);
    const mins = Math.floor((timeSec % 3600) / 60);
    const secs = Math.floor(timeSec % 60);
    let ret = ``;
    if (hrs > 0) {
      ret += `${hrs}:`;
    }

    ret += `${mins < 10 ? '0' : ''}${mins}:`;
    ret += `${secs < 10 ? '0' : ''}${secs}`;
    return ret;
  }
}
